module.exports = __webpack_public_path__ + "static/media/JustActMailers_10-11.9c935ec4.jpg";